
import { TriggerRule, Question } from "@/types/theme";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { TriggerRulesTab } from "./trigger/TriggerRulesTab";
import { TriggerLogsTab } from "./trigger/TriggerLogsTab";
import { useBuilder } from "@/contexts/BuilderContext";

interface BuilderTriggersProps {
  chatbotId: string;
  reportUnsavedChanges: (isDirty: boolean) => void;
}

export const BuilderTriggers = ({
  chatbotId,
  reportUnsavedChanges,
}: BuilderTriggersProps) => {
  // Use unified context instead of props
  const { getTriggerRules, getQuestions, updateTriggerRules } = useBuilder();

  const triggerRules = getTriggerRules();
  const questions = getQuestions();

  // Unified context handlers
  const handleAddTriggerRule = () => {
    // Generate a proper UUID instead of temporary ID
    const newId = crypto.randomUUID();

    const newTriggerRule = {
      id: newId,
      chatbot_id: chatbotId,
      name: "New Trigger",
      conditions: [],
      postVariableMappings: [],
      active: true,
      notes: '',
      webhookUrl: '',
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString()
    };

    const currentRules = getTriggerRules();
    updateTriggerRules([...currentRules, newTriggerRule]);
    reportUnsavedChanges(true);

    console.log('Added new trigger rule via unified context:', newTriggerRule);
  };

  const handleUpdateTriggerRule = (ruleId: string, updatedRule: Partial<TriggerRule>) => {
    const currentRules = getTriggerRules();
    const updatedRules = currentRules.map(rule =>
      rule.id === ruleId ? { ...rule, ...updatedRule } : rule
    );
    updateTriggerRules(updatedRules);
    reportUnsavedChanges(true);

    console.log('Updated trigger rule via unified context:', { ruleId, updatedRule });
  };

  const handleDeleteTriggerRule = (ruleId: string) => {
    const currentRules = getTriggerRules();
    const filteredRules = currentRules.filter(rule => rule.id !== ruleId);
    updateTriggerRules(filteredRules);
    reportUnsavedChanges(true);

    console.log('Deleted trigger rule via unified context:', ruleId);
  };
  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-xl font-semibold text-gray-800">Triggers</h3>
      </div>

      <Tabs defaultValue="rules" className="space-y-4">
        <TabsList>
          <TabsTrigger value="rules">Rules</TabsTrigger>
          <TabsTrigger value="logs">Logs</TabsTrigger>
        </TabsList>

        <TabsContent value="rules">
          <TriggerRulesTab
            chatbotId={chatbotId}
            triggerRules={triggerRules}
            questions={questions}
            onAddTriggerRule={handleAddTriggerRule}
            onUpdateTriggerRule={handleUpdateTriggerRule}
            onDeleteTriggerRule={handleDeleteTriggerRule}
            reportUnsavedChanges={reportUnsavedChanges}
          />
        </TabsContent>

        <TabsContent value="logs">
          <TriggerLogsTab chatbotId={chatbotId} />
        </TabsContent>
      </Tabs>
    </div>
  );
};
